import React from 'react';

export default function Chip({ label, color = 'default', size = 'medium', className = '' }) {
  const colorClasses = {
    default: 'bg-gray-100 text-gray-700 border-gray-200',
    special:'text-gray-200 border-transparent',
    primary: 'bg-primary-100 text-primary-700 border-primary-200',
    success: 'bg-green-100 text-green-700 border-green-200',
    error: 'bg-red-100 text-red-700 border-red-200',
    warning: 'bg-orange-100 text-orange-700 border-orange-200',
    info: 'bg-cyan-100 text-cyan-700 border-cyan-200',
    amber: 'bg-amber-0 text-amber-500 drop-shadow-xs border-transparent',
  };

  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    medium: 'px-3 py-1 text-sm',
  };

  return (
    <span className={`inline-flex text-[10px] items-center font-medium rounded-full border ${colorClasses[color]} ${sizeClasses[size]} ${className}`}>
      {label}
    </span>
  );
}
